<div class="{{ class() }}">
    @for (action of visibleActions(); track $index) {
        @switch (action.type) {
            @default {
                <button
                    mat-button
                    attr.data-testid="{{ testIdPrefix() }}-{{ action.testId }}-btn"
                    class="{{ action.class }}"
                    [disabled]="action.disabled"
                    (click)="action.onClick($event)"
                >
                    @if (action.icon) {
                        <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    {{ action.text }}
                </button>
            }
            @case ('flat') {
                <button
                    mat-flat-button
                    attr.data-testid="{{ testIdPrefix() }}-{{ action.testId }}-btn"
                    class="{{ action.class }} "
                    [disabled]="action.disabled"
                    (click)="action.onClick($event)"
                >
                    <div class="rcp-flex">
                        @if (action.isBusy) {
                            <mat-spinner
                                diameter="20"
                                class="rcp-mr-2"
                            ></mat-spinner>
                        }
                        @if (action.icon) {
                            <mat-icon>{{ action.icon }}</mat-icon>
                        }
                        <span> {{ action.text }}</span>
                    </div>
                </button>
            }
            @case ('raised') {
                <button
                    mat-raised-button
                    attr.data-testid="{{ testIdPrefix() }}-{{ action.testId }}-btn"
                    class="{{ action.class }} "
                    [disabled]="action.disabled"
                    (click)="action.onClick($event)"
                >
                    <div class="rcp-flex">
                        @if (action.isBusy) {
                            <mat-spinner
                                diameter="20"
                                class="rcp-mr-2"
                            ></mat-spinner>
                        }
                        @if (action.icon) {
                            <mat-icon>{{ action.icon }}</mat-icon>
                        }
                        <span> {{ action.text }} </span>
                    </div>
                </button>
            }
            @case ('stroked') {
                <button
                    mat-stroked-button
                    attr.data-testid="{{ testIdPrefix() }}-{{ action.testId }}-btn"
                    class="{{ action.class }} "
                    [disabled]="action.disabled"
                    (click)="action.onClick($event)"
                >
                    <div class="rcp-flex">
                        @if (action.isBusy) {
                            <mat-spinner
                                diameter="20"
                                class="rcp-mr-2"
                            ></mat-spinner>
                        }
                        @if (action.icon) {
                            <mat-icon>{{ action.icon }}</mat-icon>
                        }
                        <span>
                            {{ action.text }}
                        </span>
                    </div>
                </button>
            }
        }
    }
</div>
